import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const Magento = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Best Magento Development Company in USA & India | Ayanshtech Solutions – Hire Certified Magento Experts for eCommerce Design, Customization & Growth"
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="#1 Magento Development Company in USA & India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/magento"
        />
        <meta
          property="og:description"
          content="Best Magento Development Company in USA & India | Ayanshtech Solutions – Hire Certified Magento Experts for eCommerce Design, Customization & Growth"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="#1 Magento Development Company in USA & India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Best Magento Development Company in USA & India | Ayanshtech Solutions – Hire Certified Magento Experts for eCommerce Design, Customization & Growth"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/magento" />
        <title>
          #1 Magento Development Company in USA & India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6">
        <div className=" w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 lg:text-left p-4 mt-10">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Magento Development Company in USA & India
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Empower your online business with our robust and scalable
                Magento development services designed to deliver exceptional
                eCommerce experiences. As a leading Magento Development Company
                in USA & India, we specialize in building feature-rich,
                high-performance, and fully customized online stores that align
                perfectly with your brand and business goals.
                <br />
                Our team of expert Magento developers ensures seamless custom
                theme development, module integration, and third-party API
                connections to enhance your store’s functionality and user
                experience. Whether you need to migrate to Magento 2, optimize
                performance, or develop a new eCommerce platform from scratch,
                we provide end-to-end solutions that drive conversions and
                growth.
                <br />
                Delivering innovation, reliability, and scalability — we help
                you turn your eCommerce vision into reality with Magento’s
                powerful framework.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\softwareDev\magento\img1.webp"
                alt="Magento Development Company"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Magento Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Leverage the power of Magento to build eCommerce websites that are
            scalable, secure, and customizable to meet your business
            requirements.
          </p>
        </div>

        <div className=" p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom Theme Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Magento Extensions Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Third-Party Integrations</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Support and Maintenance</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Performance Optimization</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Advanced Security Features</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Magento Migration Services</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Mobile-Friendly Design</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our Magento Development Services?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our team of Magento experts ensures your eCommerce website is built
            for success with a focus on user experience, scalability, and
            security.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\softwareDev\magento\img2.svg"
                alt="Magento Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon8.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable solutions to grow with your business
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon9.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Fully customizable designs and features
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon10.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Enhanced user experience for increased conversions
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Top-notch security to protect your data
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AyanshtechAdvantage />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default Magento;
